const TransactionSlugEnum = Object.freeze({
    TradedGiftcard: 'traded-giftcard',
    BankTransfer: 'bank-transfer',
    Withdrawal: 'withdrawal',
    ReferralCommission: 'referral-commission',
    BillPayment: 'bill-payment',
    WithdrawalRefund: 'withdrawal-refund',
    CreditRefund: 'credit-refund',
})

export default TransactionSlugEnum;